// @flow
import Raven from 'raven-js'
import { sentryDSN } from '../config'

// We use the Security team DSN here as defined in Sentry
const defaultDsn = sentryDSN

export const configureAndInstall = (): any =>
  Raven.config(defaultDsn, {
    whitelistUrls: [/auth\.lanetixstaging\.com/, /login-eu\.lanetixstaging\.com/],
    release: process.env.SOURCE_VERSION
  }).install()

export const captureException = (e: Object): any =>
  Raven.captureException(JSON.stringify(e, Object.getOwnPropertyNames(e), 2))
